import { SET_CHALLENGES, SET_MY_CHALLENGES, ADD_CHALLENGE, SET_MY_CHALLENGES_HISTORIES, SET_CHALLENGES_CACHED } from "./types";

const initialState = {
    challenges: null,
    cached: {},
    myChallenges: [],
    histories: {},
};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_CHALLENGES:
            return {
                ...state,
                challenges: action.list,
                cached: {
                    ...state.cached,
                    [action.status]: action.list
                }
            }

        case SET_CHALLENGES_CACHED:
            return {
                ...state,
                cached: {
                    ...action.cached,
                }
            }

        case SET_MY_CHALLENGES:
            return {
                ...state,
                myChallenges: action.list,
            }

        case ADD_CHALLENGE:
            return {
                ...state,
                myChallenges: [
                    ...state.myChallenges,
                    action.details
                ],
            }

        case SET_MY_CHALLENGES_HISTORIES:
            return {
                ...state,
                histories: {
                    ...state.histories,
                    [action.label]: action.list
                }
            }

        default:
            return state;
    }
}